<template>
    <div class="o-navBottom">
        <transition name="fade">
            <o-menu v-if="showMenu" />
        </transition>
        <div class="o-navBottom__bar">
            <router-link
                tag="button"
                :disabled="navLinksDisabled"
                v-if="authIsAdvisor"
                class="o-navBottom__button"
                :to="{ name: 'user-add' }"
            >
                <a-icon icon="UserAddDark" />
                <p class="o-navBottom__label">Nowy Klient</p>
            </router-link>
            <router-link
                tag="button"
                :disabled="navLinksDisabled"
                v-if="authIsAdvisor"
                class="o-navBottom__button"
                :to="{ name: 'alert-add' }"
            >
                <a-icon icon="AlertAddDark" />
                <p class="o-navBottom__label">Nowy Alert</p>
            </router-link>
            <router-link
                tag="button"
                :disabled="navLinksDisabled"
                v-if="!authIsAdvisor"
                class="o-navBottom__button"
                :to="{ name: 'favorites' }"
            >
                <a-icon icon="FavoriteDark" />
                <p class="o-navBottom__label">Ulubione</p>
            </router-link>
            <router-link
                tag="button"
                :disabled="navLinksDisabled"
                v-if="!authIsAdvisor"
                class="o-navBottom__button"
                :to="{ name: 'alerts' }"
            >
                <a-icon icon="AlertDark" />
                <p class="o-navBottom__label">Alerty</p>
            </router-link>
            <router-link
                tag="button"
                :disabled="navLinksDisabled"
                class="o-navBottom__button"
                :to="{ name: 'protectors' }"
            >
                <a-icon icon="ProductsDark" />
                <p class="o-navBottom__label">Środki</p>
            </router-link>
            <router-link
                tag="button"
                :disabled="navLinksDisabled"
                class="o-navBottom__button"
                :to="{ name: 'notifications' }"
            >
                <a-icon icon="NotificationsDark" />
                <p class="o-navBottom__label">Powiadomienia</p>
            </router-link>
            <button
                @click="$store.dispatch('toggleMenu')"
                class="o-navBottom__button"
            >
                <a-icon icon="MenuDark" />
                <p class="o-navBottom__label">Menu</p>
            </button>
        </div>
    </div>
</template>

<script>
import OMenu from '@/components/OMenu'
export default {
    components: {
        OMenu
    },
    computed: {
        navLinksDisabled() {
            return !this.$store.getters[
                'subscriptions/userHasActiveSubscription'
            ]
        },
        showMenu() {
            return this.$store.getters.menuStatus
        },
        authIsAdvisor() {
            return this.$store.getters.authIsAdvisor
        }
    }
}
</script>
